module.exports = __webpack_public_path__ + "static/laura-0a41cd61df2a75c929547dac4805f5c3.jpg";